/**
 * @generated SignedSource<<be48d729468d88b6272700860531c507>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SpaceVisibility = "PRIVATE" | "PUBLIC" | "SECRET" | "%future added value";
export type communityShellQuery$variables = {
  skip: boolean;
  slug: string;
  space: string;
};
export type communityShellQuery$data = {
  readonly club: {
    readonly space?: {
      readonly isMember: boolean;
      readonly visibility: SpaceVisibility;
    };
    readonly " $fragmentSpreads": FragmentRefs<"communityShell_club">;
  };
  readonly user: {
    readonly " $fragmentSpreads": FragmentRefs<"communityShell_user">;
  } | null | undefined;
};
export type communityShellQuery = {
  response: communityShellQuery$data;
  variables: communityShellQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skip"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slug"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "space"
},
v3 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "space"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMember",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v11 = [
  (v7/*: any*/)
],
v12 = {
  "kind": "Literal",
  "name": "filterBy",
  "value": "UPCOMING"
},
v13 = {
  "kind": "Literal",
  "name": "orderBy",
  "value": "CHRONOLOGICAL"
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDate",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v18 = {
  "kind": "Literal",
  "name": "first",
  "value": 5
},
v19 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "signedUrl",
    "storageKey": null
  },
  (v7/*: any*/)
],
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalPoints",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "communityShellQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "communityShell_club"
          },
          {
            "condition": "skip",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "kind": "FragmentSpread",
            "name": "communityShell_user"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "communityShellQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SpaceGroup",
            "kind": "LinkedField",
            "name": "groups",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "spaces",
                "plural": true,
                "selections": [
                  (v9/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "icon",
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  (v10/*: any*/),
                  (v6/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "position",
                    "storageKey": null
                  },
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isSpace"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "postPolicy",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "commentPolicy",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hiddenUniversal",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PaymentIntegrationProduct",
                    "kind": "LinkedField",
                    "name": "primaryProduct",
                    "plural": false,
                    "selections": (v11/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccessGroupSpace",
                    "kind": "LinkedField",
                    "name": "accessGroups",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AccessGroup",
                        "kind": "LinkedField",
                        "name": "accessGroup",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ExternalProductAccessGroup",
                            "kind": "LinkedField",
                            "name": "externalProducts",
                            "plural": true,
                            "selections": (v11/*: any*/),
                            "storageKey": null
                          },
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ClubSubscription",
            "kind": "LinkedField",
            "name": "subscription",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ClubSubscriptionFeature",
                "kind": "LinkedField",
                "name": "features",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "key",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "value",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 10000
              }
            ],
            "concreteType": "OfferConnection",
            "kind": "LinkedField",
            "name": "offers",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "OfferEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PaymentIntegrationProduct",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "productName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "enabled",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ExternalProductAccessGroup",
                        "kind": "LinkedField",
                        "name": "accessGroup",
                        "plural": false,
                        "selections": (v11/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "offers(first:10000)"
          },
          {
            "alias": null,
            "args": [
              (v12/*: any*/),
              {
                "kind": "Literal",
                "name": "first",
                "value": 3
              },
              (v13/*: any*/)
            ],
            "concreteType": "EventConnection",
            "kind": "LinkedField",
            "name": "events",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EventEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Event",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v10/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v17/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "events(filterBy:\"UPCOMING\",first:3,orderBy:\"CHRONOLOGICAL\")"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ClubRanking",
            "kind": "LinkedField",
            "name": "ranking",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v18/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "order",
                    "value": "DESC"
                  }
                ],
                "concreteType": "RankingUserConnection",
                "kind": "LinkedField",
                "name": "users",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RankingUserEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RankingUser",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "displayName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ImageFile",
                                "kind": "LinkedField",
                                "name": "photo",
                                "plural": false,
                                "selections": (v19/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "username",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "avatarFallback",
                                "storageKey": null
                              },
                              (v7/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v20/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalPointsCurrentMonth",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalPointsLast3Months",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalPointsLastMonth",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v17/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "users(first:5,order:\"DESC\")"
              },
              {
                "alias": "rankingUsers",
                "args": [
                  (v18/*: any*/)
                ],
                "concreteType": "RankingUserConnection",
                "kind": "LinkedField",
                "name": "users",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RankingUserEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RankingUser",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v20/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "users(first:5)"
              }
            ],
            "storageKey": null
          },
          {
            "alias": "leaderboard",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "LEADERBOARD"
              }
            ],
            "kind": "ScalarField",
            "name": "configuration",
            "storageKey": "configuration(key:\"LEADERBOARD\")"
          },
          {
            "alias": "nextEvents",
            "args": [
              (v12/*: any*/),
              {
                "kind": "Literal",
                "name": "first",
                "value": 1
              },
              (v13/*: any*/)
            ],
            "concreteType": "EventConnection",
            "kind": "LinkedField",
            "name": "events",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EventEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Event",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "events(filterBy:\"UPCOMING\",first:1,orderBy:\"CHRONOLOGICAL\")"
          },
          {
            "condition": "skip",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "club",
                "variableName": "slug"
              }
            ],
            "concreteType": "CompletedClass",
            "kind": "LinkedField",
            "name": "lastCompletedClass",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "courseClass",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "nextClass",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isCourseClass"
                          },
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v21/*: any*/),
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CourseSection",
                            "kind": "LinkedField",
                            "name": "section",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              (v7/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Course",
                            "kind": "LinkedField",
                            "name": "course",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v10/*: any*/),
                              (v21/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ImageFile",
                                "kind": "LinkedField",
                                "name": "landscapeImage",
                                "plural": false,
                                "selections": (v19/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ImageFile",
                                "kind": "LinkedField",
                                "name": "portraitImage",
                                "plural": false,
                                "selections": (v19/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CourseCategory",
                                "kind": "LinkedField",
                                "name": "category",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "orientation",
                                    "storageKey": null
                                  },
                                  (v21/*: any*/),
                                  (v7/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v7/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "CourseContent",
                    "abstractKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ab2ce724b3adaa2bcf31ea516300fed4",
    "id": null,
    "metadata": {},
    "name": "communityShellQuery",
    "operationKind": "query",
    "text": "query communityShellQuery(\n  $slug: String!\n  $space: String!\n  $skip: Boolean!\n) {\n  club(slug: $slug) {\n    ...communityShell_club\n    space(slug: $space) @skip(if: $skip) {\n      __typename\n      isMember\n      visibility\n      id\n    }\n    id\n  }\n  user {\n    ...communityShell_user_20J5Pl\n    id\n  }\n}\n\nfragment communityShell_club on Club {\n  id\n  ...communitySidebarFragment\n  ...sidebarPreview\n  ...portals_club\n}\n\nfragment communityShell_user_20J5Pl on User {\n  ...portals_user_3NTTF8\n}\n\nfragment communitySidebarFragment on Club {\n  groups {\n    id\n    name\n    spaces {\n      __typename\n      id\n      icon\n      name\n      slug\n      visibility\n      isMember\n      position\n      ...spaceCreateDialog_spaceFragment\n      ...spaceDeleteDialogFragment\n    }\n    ...groupCreateDialog_updateFragment\n    ...groupDeleteDialogFragment\n  }\n  ...spaceCreateDialog_clubFragment\n  ...feedReorderDialog_feed\n}\n\nfragment feedReorderDialog_feed on Club {\n  ...feedReorderDialog_groups\n  ...feedReorderDialog_spaces\n}\n\nfragment feedReorderDialog_groups on Club {\n  groups {\n    id\n    name\n    spaces {\n      __typename\n      id\n      icon\n      name\n    }\n  }\n}\n\nfragment feedReorderDialog_spaces on Club {\n  groups {\n    id\n    name\n    spaces {\n      __typename\n      id\n      icon\n      name\n      position\n    }\n  }\n}\n\nfragment groupCreateDialog_updateFragment on SpaceGroup {\n  id\n  name\n}\n\nfragment groupDeleteDialogFragment on SpaceGroup {\n  id\n  name\n  spaces {\n    __typename\n    id\n  }\n}\n\nfragment portals_club on Club {\n  nextEvents: events(orderBy: CHRONOLOGICAL, filterBy: UPCOMING, first: 1) {\n    edges {\n      node {\n        id\n        ...portals_eventPortal\n      }\n    }\n  }\n}\n\nfragment portals_coursePortal on CourseClass {\n  __isCourseClass: __typename\n  id\n  name\n  active\n  slug\n  section {\n    active\n    id\n  }\n  course {\n    name\n    slug\n    active\n    landscapeImage {\n      signedUrl\n      id\n    }\n    portraitImage {\n      signedUrl\n      id\n    }\n    category {\n      orientation\n      active\n      id\n    }\n    id\n  }\n}\n\nfragment portals_eventPortal on Event {\n  id\n  title\n  startDate\n  endDate\n  slug\n}\n\nfragment portals_user_3NTTF8 on User {\n  lastCompletedClass(club: $slug) {\n    id\n    courseClass {\n      __typename\n      ... on CourseContent {\n        nextClass {\n          __typename\n          ...portals_coursePortal\n          id\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment sidebarPreview on Club {\n  ...sidebarPreviewEvents\n  ...sidebarPreviewLeaderboard_2CNdqq\n  leaderboard: configuration(key: \"LEADERBOARD\")\n  events(orderBy: CHRONOLOGICAL, filterBy: UPCOMING, first: 3) {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  ranking {\n    rankingUsers: users(first: 5) {\n      edges {\n        node {\n          totalPoints\n        }\n      }\n    }\n  }\n}\n\nfragment sidebarPreviewEvents on Club {\n  events(orderBy: CHRONOLOGICAL, filterBy: UPCOMING, first: 3) {\n    edges {\n      node {\n        id\n        slug\n        title\n        startDate\n        endDate\n      }\n      cursor\n    }\n  }\n}\n\nfragment sidebarPreviewLeaderboard_2CNdqq on Club {\n  ranking {\n    users(first: 5, order: DESC) {\n      edges {\n        node {\n          user {\n            displayName\n            photo {\n              signedUrl\n              id\n            }\n            username\n            avatarFallback\n            id\n          }\n          totalPoints\n          totalPointsCurrentMonth\n          totalPointsLast3Months\n          totalPointsLastMonth\n        }\n        cursor\n      }\n    }\n  }\n  id\n}\n\nfragment spaceCreateDialog_clubFragment on Club {\n  id\n  slug\n  groups {\n    spaces {\n      __typename\n      id\n      name\n    }\n    id\n  }\n  subscription {\n    features {\n      key\n      value\n    }\n    id\n  }\n  offers(first: 10000) {\n    edges {\n      node {\n        id\n        productName\n        enabled\n        accessGroup {\n          id\n        }\n      }\n    }\n  }\n  ...upgradePlanCard_clubFragment\n}\n\nfragment spaceCreateDialog_spaceFragment on Space {\n  __isSpace: __typename\n  id\n  name\n  icon\n  visibility\n  postPolicy\n  commentPolicy\n  hiddenUniversal\n  primaryProduct {\n    id\n  }\n  accessGroups {\n    accessGroup {\n      externalProducts {\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment spaceDeleteDialogFragment on Space {\n  __isSpace: __typename\n  id\n  name\n}\n\nfragment upgradePlanCard_clubFragment on Club {\n  subscription {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "05b571f0661b474cb4cc52435878b491";

export default node;
